import { Component as Casement } from 'src/assets/icons/windows/casement.svg';
import { Component as Colonial } from 'src/assets/icons/windows/colonial.svg';
import { Component as Diamond } from 'src/assets/icons/windows/diamond.svg';
import { Component as Double_Hung } from 'src/assets/icons/windows/double_hung.svg';
import { Component as Farmhouse } from 'src/assets/icons/windows/farmhouse.svg';
import { Component as None } from 'src/assets/icons/windows/none.svg';
import { Component as Prairie } from 'src/assets/icons/windows/prairie.svg';
import { Component as Slider } from 'src/assets/icons/windows/slider.svg';
import { Component as Valance } from 'src/assets/icons/windows/valance.svg';
import asphalt from 'src/assets/img/ds-menu/asphaltRoof.png';
import brick from 'src/assets/img/ds-menu/brick.png';
import concrete from 'src/assets/img/ds-menu/concrete.png';
import handSplit from 'src/assets/img/ds-menu/handSplit.png';
import horizontal from 'src/assets/img/ds-menu/horizontal.png';
import metal from 'src/assets/img/ds-menu/metalRoof.png';
import scalloped from 'src/assets/img/ds-menu/scalloped.png';
import shingles from 'src/assets/img/ds-menu/shingles.png';
import staggeredShake from 'src/assets/img/ds-menu/staggeredShake.png';
import stone from 'src/assets/img/ds-menu/stone.png';
import straightShake from 'src/assets/img/ds-menu/straightShake.png';
import stucco from 'src/assets/img/ds-menu/stucco.png';
import tile from 'src/assets/img/ds-menu/tileRoof.png';
import vertical from 'src/assets/img/ds-menu/vertical.png';
import casementColonial from 'src/assets/img/ds-menu/windows-changes/casement-colonial.png';
import casementDiamond from 'src/assets/img/ds-menu/windows-changes/casement-diamond.png';
import casementFarmhouse from 'src/assets/img/ds-menu/windows-changes/casement-farmhouse.png';
import casementNone from 'src/assets/img/ds-menu/windows-changes/casement-none.png';
import casementPrairie from 'src/assets/img/ds-menu/windows-changes/casement-prairie.png';
import casementValance from 'src/assets/img/ds-menu/windows-changes/casement-valance.png';
import dbleHungColonial from 'src/assets/img/ds-menu/windows-changes/dblehung-colonial.png';
import dbleHungDiamond from 'src/assets/img/ds-menu/windows-changes/dblehung-diamond.png';
import dbleHungFarmhouse from 'src/assets/img/ds-menu/windows-changes/dblehung-farmhouse.png';
import dbleHungNone from 'src/assets/img/ds-menu/windows-changes/dblehung-none.png';
import dbleHungPrairie from 'src/assets/img/ds-menu/windows-changes/dblehung-prairie.png';
import dbleHungValance from 'src/assets/img/ds-menu/windows-changes/dblehung-valance.png';
import sliderColonial from 'src/assets/img/ds-menu/windows-changes/slider-colonial.png';
import sliderDiamond from 'src/assets/img/ds-menu/windows-changes/slider-diamond.png';
import sliderFarmhouse from 'src/assets/img/ds-menu/windows-changes/slider-farmhouse.png';
import sliderNone from 'src/assets/img/ds-menu/windows-changes/slider-none.png';
import sliderPrairie from 'src/assets/img/ds-menu/windows-changes/slider-prairie.png';
import sliderValance from 'src/assets/img/ds-menu/windows-changes/slider-valance.png';

import { DesignConfigCategories } from './designConfig';
import { FrameStyles, GridStyles } from './hardCodedData/windowParametricData';

enum Menu {
  ACCENT = 'ACCENT',
  DOOR = 'DOOR',
  RESET = 'RESET',
  ROOF = 'ROOF',
  TEMPLATE = 'TEMPLATE',
  TRIM = 'TRIM',
  VERSION = 'VERSION',
  WALL = 'WALL',
  WINDOW = 'WINDOW',
  SHARE = 'SHARE',
  SHOW_DESIGN = 'SHOW_DESIGN',
  INTERACTIVE_RENDERING_WALL = 'INTERACTIVE_RENDERING_WALL',
  INTERACTIVE_RENDERING_ROOF = 'INTERACTIVE_RENDERING_ROOF',
  INTERACTIVE_RENDERING_TRIM = 'INTERACTIVE_RENDERING_TRIM',
  INSPIRE_ME = 'INSPIRE_ME',
}

const WindowConfigImgs = {
  [FrameStyles.CASEMENT]: {
    [GridStyles.COLONIAL]: casementColonial,
    [GridStyles.FARMHOUSE]: casementFarmhouse,
    [GridStyles.NONE]: casementNone,
    [GridStyles.PRAIRIE]: casementPrairie,
    [GridStyles.VALANCE]: casementValance,
    [GridStyles.DIAMOND]: casementDiamond,
  },
  [FrameStyles.DOUBLE_HUNG]: {
    [GridStyles.COLONIAL]: dbleHungColonial,
    [GridStyles.FARMHOUSE]: dbleHungFarmhouse,
    [GridStyles.NONE]: dbleHungNone,
    [GridStyles.PRAIRIE]: dbleHungPrairie,
    [GridStyles.VALANCE]: dbleHungValance,
    [GridStyles.DIAMOND]: dbleHungDiamond,
  },
  [FrameStyles.SLIDER]: {
    [GridStyles.COLONIAL]: sliderColonial,
    [GridStyles.FARMHOUSE]: sliderFarmhouse,
    [GridStyles.NONE]: sliderNone,
    [GridStyles.PRAIRIE]: sliderPrairie,
    [GridStyles.VALANCE]: sliderValance,
    [GridStyles.DIAMOND]: sliderDiamond,
  },
};

const MenuToFeatureCategoryMap = {
  [Menu.WALL]: DesignConfigCategories.WALL,
  [Menu.ROOF]: DesignConfigCategories.ROOF,
  [Menu.TRIM]: DesignConfigCategories.TRIM,
  [Menu.WINDOW]: DesignConfigCategories.WINDOW,
} as const;

enum Types {
  HORIZONTAL_SIDING = 'horizontal',
  VERTICAL_SIDING = 'vertical',
  SHINGLED_SIDING = 'shingles',
  BRICK = 'brick',
  STONE = 'stone',
  CONCRETE = 'concrete',
  STUCCO = 'stucco',
  ASPHALT = 'asphalt',
  TILE = 'tile',
  METAL = 'metal',
}

enum TextureTypes {
  CEDARMILL = 'Cedarmill',
  SMOOTH = 'Smooth',
}

enum Shapes {
  STRAIGHT_SHAKE = 'Straight Shake',
  STAGGERED_SHAKE = 'Staggered Shake',
  SCALLOPED = 'Scalloped',
  HAND_SPLIT = 'Hand Split',
}

enum Styles {
  CLAPBOARD = 'Clapboard',
  DUTCH_LAP = 'Dutch Lap',
  BOARD_AND_BATTEN = 'Board and Batten',
  LAP = 'Lap',
  POURED = 'Poured',
  CINDERBLOCK = 'Cinderblock',
  STUCCO = 'Stucco',
  PANEL = 'Panel',
  TUDOR = 'Tudor',
}

interface ShapeFilterItemType {
  id: Shapes;
  thumbnail: string;
}

const ShapesFilterItems = [
  {
    id: Shapes.STAGGERED_SHAKE,
    thumbnail: staggeredShake,
  },
  {
    id: Shapes.SCALLOPED,
    thumbnail: scalloped,
  },
  {
    id: Shapes.STRAIGHT_SHAKE,
    thumbnail: straightShake,
  },
  {
    id: Shapes.HAND_SPLIT,
    thumbnail: handSplit,
  },
];

interface TypesFilterItemType {
  id: Types;
  name: string;
  thumbnail: string;
}

// Order determines order in menu
const TypesFilterItems = [
  {
    id: Types.HORIZONTAL_SIDING,
    name: 'Horizontal',
    thumbnail: horizontal,
  },
  {
    id: Types.VERTICAL_SIDING,
    name: 'Vertical',
    thumbnail: vertical,
  },
  {
    id: Types.SHINGLED_SIDING,
    name: 'Shingles',
    thumbnail: shingles,
  },
  {
    id: Types.BRICK,
    name: 'Brick',
    thumbnail: brick,
  },
  {
    id: Types.STONE,
    name: 'Stone',
    thumbnail: stone,
  },
  {
    id: Types.CONCRETE,
    name: 'Concrete',
    thumbnail: concrete,
  },
  {
    id: Types.STUCCO,
    name: 'Stucco',
    thumbnail: stucco,
  },
  {
    id: Types.ASPHALT,
    name: 'Shingles',
    thumbnail: asphalt,
  },
  {
    id: Types.TILE,
    name: 'Tile',
    thumbnail: tile,
  },
  {
    id: Types.METAL,
    name: 'Metal',
    thumbnail: metal,
  },
];

interface WindowFilterItemTypes {
  id: GridStyles | FrameStyles;
  label: string;
  icon: React.FunctionComponent;
}
const GridFilterItems = [
  {
    id: GridStyles.NONE,
    icon: None,
    label: 'None',
  },
  {
    id: GridStyles.COLONIAL,
    icon: Colonial,
    label: 'Colonial',
  },
  {
    id: GridStyles.DIAMOND,
    icon: Diamond,
    label: 'Diamond',
  },
  {
    id: GridStyles.FARMHOUSE,
    icon: Farmhouse,
    label: 'Farmhouse',
  },
  {
    id: GridStyles.PRAIRIE,
    icon: Prairie,
    label: 'Prairie',
  },
  {
    id: GridStyles.VALANCE,
    icon: Valance,
    label: 'Valance',
  },
];

const FrameFilterItems = [
  {
    id: FrameStyles.CASEMENT,
    icon: Casement,
    label: 'Casement',
  },
  {
    id: FrameStyles.DOUBLE_HUNG,
    icon: Double_Hung,
    label: 'Dble. Hung',
  },
  {
    id: FrameStyles.SLIDER,
    icon: Slider,
    label: 'Slider',
  },
];

export {
  Menu,
  MenuToFeatureCategoryMap,
  Shapes,
  ShapesFilterItems,
  Styles,
  TextureTypes,
  Types,
  TypesFilterItems,
  GridFilterItems,
  FrameFilterItems,
  WindowConfigImgs,
};

export type { TypesFilterItemType, ShapeFilterItemType, WindowFilterItemTypes };
